import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon } from '@material-ui/icons'
import { DetailTableProps } from './types'

import { BooleanField, ValueField } from 'src/components/Table'
import { ClientUserDialog } from 'src/modules/supply_chain/components/ClientUserDialog'
import { DetailComponent } from './base'

interface  ClientUserDetailTableProps extends DetailTableProps {
  clientGuid: string
}

export const ClientUserDetailTable = (props: ClientUserDetailTableProps) => {
  const { obj, refresh, clientGuid } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <ClientUserDialog
          open={updateOpen}
          user={obj.data}
          clientGuid={clientGuid}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          { Icon: EditIcon, actions: [{ title: 'Edit User', onClick: () => setUpdateOpen(true) }] },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'email', label: 'E-Mail', renderer: ValueField },
          { id: 'firstName', label: 'First Name', renderer: ValueField },
          { id: 'lastName', label: 'Last Name', renderer: ValueField },
          { id: 'isActive', label: 'Active?', renderer: BooleanField },
        ]}
      />
    </>
  )
}
